import csTools from 'cornerstone-tools';
import { PIXELS_NEAR_TOOL } from '~/constants';

const lineSegDistance = csTools.importInternal('util/lineSegDistance');

/**
 * @public
 * @class Length
 * @memberof Tools.Annotation
 * @classdesc Tool for measuring distances.
 * @extends Tools.Annotation.Length
 * @author Ricardo Aguirre <ricardo.a.nava@gmail.com>
 * Created at 2022-03-16
 */
export default class CustomLength extends csTools.LengthTool {
  name;
  constructor(props) {
    super(props);
  }

  /**
   *
   *
   * @param {*} element
   * @param {*} data
   * @param {*} coords
   * @returns {Boolean}
   */
  pointNearTool(element, data, coords) {
    const hasStartAndEndHandles = data && data.handles && data.handles.start && data.handles.end;
    const validParameters = hasStartAndEndHandles;

    if (!validParameters) {
      csTools.logger.warn(`invalid parameters supplied to tool ${this.name}'s pointNearTool`);

      return false;
    }

    if (data.visible === false) return false;

    const segDistance = lineSegDistance(element, data.handles.start, data.handles.end, coords);
    return segDistance < PIXELS_NEAR_TOOL;
  }
}
